import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { fetchSalesInvoiceDetail, fetchSalesInvoiceCompletedDetail, fetchCustomerItem } from '../../actions/salesInvoice_actions';
import { createSalesReturn, editSalesReturn, fetchSalesReturnDetail, setValue, setSaleRowValue, completeReturn } from '../../actions/sales_actions';
import RestockReturnForm from '../../components/Returns/restockReturnForm';

const restockReturnForm = reduxForm({
  form: 'restockReturnForm',
})(RestockReturnForm);

const selector = formValueSelector('restockReturnForm');

function mapStateToProps(state) {
  const Promo = selector(state, 'Promo');
  const Tax = selector(state, 'Tax');
  const RestockingFee = selector(state, 'RestockingFee');
  const Customers = selector(state, 'Customers');
  const Item = selector(state, 'Item');
  const searchValue = selector(state, 'ProductInformation');
  const searchType = selector(state, 'searchType');
  const Quantity = selector(state, 'Quantity');
  const Weight = selector(state, 'Weight');
  const UnitPrice = selector(state, 'UnitPrice');

  return {
    Promo,
    Tax,
    RestockingFee,
    Customers,
    Item,
    searchValue,
    searchType,
    Quantity,
    Weight,
    UnitPrice,

    currentSalesInvoice: state.salesInvoice.currentSalesInvoice,
    salesInvoiceDetail: (state.salesInvoice.currentSalesInvoiceDetail) ? state.salesInvoice.currentSalesInvoiceDetail.data : state.salesInvoice.currentSalesInvoiceDetail,
    salesReturnDetail: state.salesInvoice.salesReturnDetail,
    initialValues: state.salesInvoice.salesReturnDetail,
    currentCustomer: state.customers.currentCustomer,
    customerItem: state.salesInvoice.customerItem,
    inventoryReturnIsLoading: state.salesInvoice.inventoryReturnIsLoading,
  };
}

export default connect(mapStateToProps, {
  fetchSalesInvoiceDetail,
  fetchCustomerItem,
  editSalesReturn,
  fetchSalesInvoiceCompletedDetail,
  createSalesReturn,
  fetchSalesReturnDetail,
  setValue,
  setSaleRowValue,
  completeReturn,
})(restockReturnForm);



// WEBPACK FOOTER //
// ./master/jsx/containers/Returns/restockReturnForm.jsx